import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from '@/router/index'
import routeNames from '@/router/routeNames'
import store from '@/store/index'
import Vuelidate from 'vuelidate'
import i18n from './i18n'
import VueCurrencyInput from 'vue-currency-input'
import { addUnauthorizedInterceptor, removeUnauthorizedInterceptor } from '@/services/api'

// Import style files
import './styles/index.scss'

Vue.use(Vuelidate)
Vue.use(VueCurrencyInput)

Vue.config.productionTip = false

/**
 * Setup 401 interceptor to handle session expiration
 */
store.subscribe((mutation) => {
  switch (mutation.type) {
    case 'auth/connect':
      addUnauthorizedInterceptor(() => {
        store.dispatch('auth/disconnectUser')
        store.dispatch('errorMessage', 'Votre session a expirée. Merci de bien vouloir vous reconnecter.')
      })
      break;
    case 'auth/disconnect':
      removeUnauthorizedInterceptor()
      break;
    default:
      break;
  }
})

/**
 * Auto reconnect
 */
router.beforeEach(async (to, from, next) => {
  if (!store.state.auth.isLogged) {
    await store.dispatch('auth/reconnect')
    await store.dispatch('license/loadLicense')
  }

  next()
})

/**
 * Check login global guard
 */
router.beforeEach(async (to, from, next) => {
  !store.state.auth.isLogged && to.name !== routeNames.login
    ? next({name: routeNames.login}) : next()
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
